import {_Prodotti as Prodotti} from "./_Prodotti";

export const ModuloEcommerceAPI = {
    Prodotti: Prodotti
};